export const REPLACEMENT_STATUSES = {
    not_started: 'not_started',
    replacement_scanned: 'replacement_scanned',
    replacement_scanned_again: 'replacement_scanned_again',
    before_shipment_scanned: 'before_shipment_scanned',
    shipped: 'shipped',
    replaced: 'replaced',
    replace_cancelled: 'replace_cancelled',
    replace_failed: 'replace_failed',
    replacement_device_removed: 'replacement_device_removed'
}

export const REPLACEMENT_STATUSES_DE = {
    not_started: 'Nicht gestartet',
    replacement_scanned: 'Ersatz wurde gescannt',
    replacement_scanned_again: 'Ein weiterer Ersatz wurde gescannt',
    before_shipment_scanned: 'Vor dem Versand gescannt',
    shipped: 'Versendet',
    replaced: 'Ersetzt',
    replace_cancelled: 'Ersatz wurde rückgängig gemacht',
    replace_failed: 'Ersetzung fehlgeschlagen',
    replacement_device_removed: 'Ersatz wurde gelöscht'
}
